"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManagePaymentMethods = exports.getDefaultPaymentMethodId = void 0;
const api_1 = require("core/api");
const CustomerService_1 = require("core/api/services/CustomerService");
const UserService_1 = require("core/api/services/UserService");
const utils_1 = require("core/utils");
const useRequest_1 = require("hooks/useRequest");
const react_1 = require("react");
const getDefaultPaymentMethodId = (paymentMethods) => {
    if (!paymentMethods?.length) {
        return;
    }
    return paymentMethods.find((pm) => pm.isDefault)?.id;
};
exports.getDefaultPaymentMethodId = getDefaultPaymentMethodId;
const useManagePaymentMethods = () => {
    const { isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const [subscription, setSubscription] = (0, react_1.useState)();
    const [paymentMethods, setPaymentMethods] = (0, react_1.useState)();
    const [selectedId, setSelectedId] = (0, react_1.useState)();
    const [addingMethod, setAddingMethod] = (0, react_1.useState)(false);
    const urlParams = new URLSearchParams(window.location.search);
    const externalSubscriptionId = urlParams?.get('external_subscription_id') || undefined;
    const fetchPaymentMethods = async () => {
        const { data } = await makeRequest(async () => CustomerService_1.CustomerService.getMyPaymentMethods(externalSubscriptionId));
        const result = data?.paymentMethods ?? [];
        setPaymentMethods(result);
        setSelectedId((0, exports.getDefaultPaymentMethodId)(result) || selectedId);
    };
    const fetchUserSubscription = async () => {
        const { data } = await makeRequest(async () => UserService_1.UserService.getUserSubscription());
        if (data?.subscription && data?.subscription?.platform === 'web') {
            setSubscription(data.subscription);
            if (data.subscription?.paymentMethodId) {
                setSelectedId(data.subscription.paymentMethodId);
            }
        }
    };
    const createPaymentMethod = async () => {
        setAddingMethod(true);
        const { data } = await makeRequest(async () => CustomerService_1.CustomerService.setupPaymentMethod({
            context: api_1.SetupPaymentMethodContext.USER,
            externalSubscriptionId,
        }));
        if (data?.setupUrl) {
            (0, utils_1.redirectTo)(data.setupUrl);
        }
        setAddingMethod(false);
    };
    const setDefaultPaymentMethod = async (paymentMethodId) => {
        if (paymentMethodId === selectedId) {
            return;
        }
        const { data } = await makeRequest(async () => UserService_1.UserService.updateSubscriptionPaymentMethod({
            paymentMethodId,
            externalSubscriptionId,
        }), 'Success');
        if (data?.success) {
            setSelectedId(paymentMethodId);
        }
    };
    (0, react_1.useEffect)(() => {
        Promise.all([fetchPaymentMethods(), fetchUserSubscription()]);
    }, []);
    return {
        paymentMethods,
        subscription,
        isProcessing,
        createPaymentMethod,
        setDefaultPaymentMethod,
        selectedId,
        addingMethod,
    };
};
exports.useManagePaymentMethods = useManagePaymentMethods;
